/**
 * @generated SignedSource<<408f0929c550c17de3e45c54ccc50843>>
 * @relayHash 2ba82ef3194d6435da85787eb8d718e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa4b82a5dd981a817de03e11fcb3d41fcffdc099a4975909d8fbe2c38c20d335

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceCreatePagePropertyInput = {
  key: string;
  pageId: string;
  value: string;
};
export type useEmojiEverSetPropertyMutation$variables = {
  input: ConfluenceCreatePagePropertyInput;
};
export type useEmojiEverSetPropertyMutation$data = {
  readonly confluence: {
    readonly createPageProperty: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly pageProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useEmojiEverSetPropertyMutation = {
  response: useEmojiEverSetPropertyMutation$data;
  variables: useEmojiEverSetPropertyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "value"
},
v5 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEmojiEverSetPropertyMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConfluenceCreatePagePropertyPayload",
            "kind": "LinkedField",
            "name": "createPageProperty",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "pageProperty",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmojiEverSetPropertyMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConfluenceCreatePagePropertyPayload",
            "kind": "LinkedField",
            "name": "createPageProperty",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "pageProperty",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2ba82ef3194d6435da85787eb8d718e5",
    "id": "fa4b82a5dd981a817de03e11fcb3d41fcffdc099a4975909d8fbe2c38c20d335",
    "metadata": {},
    "name": "useEmojiEverSetPropertyMutation",
    "operationKind": "mutation",
    "text": "mutation useEmojiEverSetPropertyMutation($input:ConfluenceCreatePagePropertyInput!){confluence{createPageProperty(input:$input){success,pageProperty{key,value,id},errors{message}}}}"
  }
};
})();

(node as any).hash = "771265924e6d3ef23e44e1c16875a2ba";

export default node;
